// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function hasValue(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=has-value.js.map